import { Text } from '@iwoca/orion-ui';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { FormattedMessage } from 'react-intl';

import { DocumentCard } from './DocumentCard';
import { Document } from '../types';

export const DocumentList = ({
    documents,
    setSelectedDocument
}: {
    documents: Document[];
    setSelectedDocument: (document: Document) => void;
}) => {
    const hasSignedAllDocuments = !documents.some(
        (document) => !document.agreed
    );

    return (
        <div className="mx-auto max-w-3xl px-l">
            <Text className="my-2xl">
                <h1>
                    <FormattedMessage
                        id="_.credit_card.onboarding.document_list.title"
                        defaultMessage="Read and sign agreements"
                    />
                </h1>
                <Text className="text-xl">
                    <FormattedMessage
                        id="_.credit_card.onboarding.document_list.description"
                        defaultMessage="You can complete the steps below in any order."
                    />
                </Text>
            </Text>

            <div className="mb-3xl space-y-m">
                {documents.map((document) => (
                    <DocumentCard
                        key={document.id}
                        document={document}
                        onClick={setSelectedDocument}
                    />
                ))}
            </div>
            {hasSignedAllDocuments && (
                <NEW_IwLinkButton variant="primary" to={{ pathname: '' }}>
                    <Text className="text-m font-bold text-structure-100">
                        <FormattedMessage
                            id="_.credit_card.onboarding.documents.continue"
                            defaultMessage="Confirm and Continue"
                        />
                    </Text>
                </NEW_IwLinkButton>
            )}
        </div>
    );
};
